import React from 'react';
import { Typography } from '@mui/material';

// The body of the guidance window when the company has a custom prompt
// (FWAPI helpers/guidancePrompt.js, mode 'freeform'): the model's answer is
// plain text written for the worker, shown as returned. There is no score and
// no rubric to break it into sections, so the only job here is to keep the
// line breaks and bullets the model used.
const FreeformGuidance = ({ text }) => (
    <Typography
        variant="body2"
        component="div"
        sx={{ color: '#1e293b', lineHeight: 1.5, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
    >
        {text}
    </Typography>
);

export default FreeformGuidance;
